import { Injectable } from '@angular/core';
import { error } from 'console';
import * as CryptoJS from 'crypto-js';

const secretKey = 'rakeemart-client-super-secret-key';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  static readonly APP_PREFIX = 'rakee-';

  /**
   * Sets item in local storage
   *
   * @param {string} key
   * @param {unknown} value
   */
  setItem(key: string, value: unknown) {
    try {
      const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(value), secretKey).toString();
      localStorage.setItem(`${LocalStorageService.APP_PREFIX}${key}`, encryptedData);
      // localStorage.setItem(
      //   `${LocalStorageService.APP_PREFIX}${key}`,
      //   JSON.stringify(value)
      // );
    } catch {
      const encryptedData = CryptoJS.AES.encrypt(value, secretKey).toString();
      localStorage.setItem(`${LocalStorageService.APP_PREFIX}${key}`, encryptedData);
      // localStorage.setItem(`${LocalStorageService.APP_PREFIX}${key}`, value as string);
    }
  }

  /**
   * Gets item from local storage by key
   *
   * @param {string} key
   * @return {*}  {unknown}
   */
  getItem(key: string): any {
    const value = localStorage.getItem(`${LocalStorageService.APP_PREFIX}${key}`);

    if (!value) {
      return '';
    }
    try {
      const decryptedData = CryptoJS.AES.decrypt(value || '', secretKey).toString(CryptoJS.enc.Utf8);
      if (!decryptedData) {
        console.error(`Failed to decrypt data for key: ${key}`);
        return null;
      }
      try {
        return JSON.parse(decryptedData as string);
      } catch {
        return decryptedData as string;
      }
    } catch(error) {
      console.log(">>>> errpor", error);
      return null;
    }
    

  }

  /**
   * Removes item from local storage by key
   *
   * @param {string} key
   */
  removeItem(key: string) {
    localStorage.removeItem(`${LocalStorageService.APP_PREFIX}${key}`);
  }
}
